export const ONE_BY_ONE_PIXEL_TRANSPARENT_IMG = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
const getBlockImageWithFallback = (imageField) => {
  if (typeof imageField === "string")
    return imageField;
  if (!imageField.src)
    return ONE_BY_ONE_PIXEL_TRANSPARENT_IMG;
  return imageField.src;
};
export default getBlockImageWithFallback;
